import {
  useState, useContext, createContext, useEffect
} from 'react'

const FormContext = createContext()

export const useFormContext = () => useContext(FormContext)

export default function FormProvider({ children }) {
  const [errors, setErrors] = useState({})
  const [schema, setSchema] = useState([])
  const [values, setValues] = useState({})
  const [isFormValid, setIsFormValid] = useState(false)
  const [isValidateTrigger, setIsValidateTrigger] = useState(false)

  const handleChange = (e, name, val) => {
    const fieldName = e?.target?.name || name
    const { [fieldName]: value, ...errorWithoutCurrentField } = errors
    setErrors({
      ...errorWithoutCurrentField
    })
    setValues({
      ...values,
      [fieldName]: e !== null ? e?.target?.value : val
    })
  }

  useEffect(() => {
    if (isValidateTrigger) {
      setIsValidateTrigger(false)
      if (Object.keys(errors).length > 0) {
        setIsFormValid(false)
        return
      }
      setIsFormValid(true)
    }
  }, [errors, isValidateTrigger])

  const validateForm = () => {
    let errorsObj = {}
    setErrors({})
    schema.forEach(({
      field, required, displayName, format
    }) => {
      const value = values[field]
      let errorMessage = ''
      if (required && (!value || (typeof value === 'object' && Object.keys(value).length === 0 ))) {
        errorMessage = `กรุณากรอก ${displayName}`
        errorsObj = {
          ...errorsObj,
          [field]: errorMessage
        }
      } else if (value && format && !format.test(value)) {
        errorMessage = `${displayName} ผิดรูปแบบ`
        errorsObj = {
          ...errorsObj,
          [field]: errorMessage
        }
      }
    })
    setErrors({
      ...errorsObj
    })
    setIsValidateTrigger(true)
  }

  useEffect(() => {
    if (Object.keys(errors).length) {
      const element = document.querySelector('[invalid=true]')
      const y = element.getBoundingClientRect().top + window.pageYOffset - 230
      window.scrollTo({ top: y, behavior: 'smooth' })
    }
  }, [errors])

  return (
    <FormContext.Provider value={{
      errors,
      setErrors,
      values,
      setValues,
      validateForm,
      handleChange,
      setSchema,
      isFormValid,
      setIsFormValid
    }}
    >
      {children}
    </FormContext.Provider>
  )
}

// const schema = [
//   {
//     field: 'nickName',
//     displayName: 'ชื่อเล่น',
//     required: true,
//     inputType: 'input',
//     type: 'text'
//   },
//   {
//     field: 'firstName',
//     displayName: 'ชื่อ',
//     required: true,
//     inputType: 'input',
//     type: 'text'
//   },
//   {
//     field: 'lastName',
//     displayName: 'นามสกุล',
//     required: true,
//     inputType: 'input',
//     type: 'text'
//   },
//   {
//     field: 'phone',
//     displayName: 'เบอร์โทรศัพท์',
//     required: true,
//     inputType: 'input',
//     type: 'text',
//     // eslint-disable-next-line
//     format: /^0([23457]\d{7}|[689]\d{8})$/g
//   },
//   {

//     field: 'facebook',
//     displayName: 'Facebook',
//     required: true,
//     inputType: 'input',
//     type: 'text'
//     // eslint-disable-next-line
//   },
//   {

//     field: 'lineId',
//     displayName: 'Line ID',
//     required: true,
//     inputType: 'input',
//     type: 'text'
//     // eslint-disable-next-line
//   },
//   {

//     field: 'address',
//     displayName: 'ที่อยู่',
//     required: true,
//     inputType: 'textarea',
//     span: true
//   },
//   {

//     field: 'province',
//     displayName: 'จังหวัด',
//     required: true,
//     inputType: 'input',
//     type: 'text'
//     // eslint-disable-next-line
//   },
//   {

//     field: 'postCode',
//     displayName: 'รหัสไปรษณีย์',
//     required: true,
//     inputType: 'input',
//     type: 'text'
//     // eslint-disable-next-line
//   },
//   {

//     field: 'email',
//     displayName: 'อีเมล',
//     required: true,
//     inputType: 'input',
//     type: 'text',
//     // eslint-disable-next-line
//     format: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
//   },
//   {

//     field: 'password',
//     displayName: 'รหัสผ่าน',
//     required: true,
//     inputType: 'input',
//     type: 'password'
//     // eslint-disable-next-line
//   },
//   {

//     field: 'confirmPassword',
//     displayName: 'ยืนยันรหัสผ่าน',
//     required: true,
//     inputType: 'input',
//     type: 'password'
//     // eslint-disable-next-line
//   },
// ]
